import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { MOBILE_SCREENSHARE_OVERLAY_Z_INDEX } from '../../constants';
import MobileScreensharePresenterPip from './MobileScreensharePresenterPip';
import MobileScreenshareRotateButton from './MobileScreenshareRotateButton';
const useStyles = makeStyles()(() => {
    return {
        overlay: {
            bottom: 0,
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: MOBILE_SCREENSHARE_OVERLAY_Z_INDEX
        }
    };
});
/**
 * 手机 Web 端屏幕共享聚焦层：右上角共享者小窗 + 右下角横竖屏切换。
 *
 * @returns {ReactElement}
 */
function MobileScreenshareOverlay() {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.overlay, id: 'mobile-screenshare-overlay' },
        React.createElement(MobileScreensharePresenterPip, null),
        React.createElement(MobileScreenshareRotateButton, null)));
}
export default MobileScreenshareOverlay;
